// frontend/src/pages/EmployeeList.tsx
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { useState } from "react";

const api = {
  list: () => fetch("/api/v1/hr.employee", { headers: { "X-Dev-Auth": "dev", "X-Tenant-ID": "1" } }).then((r: any) => r.json()).then((r: any) => r.ok ? r.data : []),
  depts: () => fetch("/api/v1/hr.department", { headers: { "X-Dev-Auth": "dev", "X-Tenant-ID": "1" } }).then((r: any) => r.json()).then((r: any) => r.ok ? r.data : []),
  create: (data: any) => fetch("/api/v1/hr.employee", { method: "POST", headers: { "Content-Type": "application/json", "X-Dev-Auth": "dev", "X-Tenant-ID": "1" }, body: JSON.stringify(data) }).then((r: any) => r.json()),
};

export default function EmployeeList() {
  const qc = useQueryClient();
  const { data: employees } = useQuery({ queryKey: ["employees"], queryFn: api.list });
  const { data: departments } = useQuery({ queryKey: ["departments"], queryFn: api.depts });
  const [form, setForm] = useState({ name: "", jobTitle: "", departmentId: "", workEmail: "" });
  const [showForm, setShowForm] = useState(false);

  const mut = useMutation({
    mutationFn: () => api.create({ name: form.name, jobTitle: form.jobTitle, departmentId: parseInt(form.departmentId) || null, workEmail: form.workEmail }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["employees"] }); setShowForm(false); setForm({ name: "", jobTitle: "", departmentId: "", workEmail: "" }); },
  });

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Employees</h1>
        <button onClick={() => setShowForm(!showForm)} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">+ Add Employee</button>
      </div>
      {showForm && (
        <form onSubmit={(e) => { e.preventDefault(); mut.mutate(); }} className="bg-white rounded-xl shadow-sm border p-4 mb-6 space-y-3 max-w-lg">
          <input placeholder="Name *" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" required />
          <input placeholder="Job Title" value={form.jobTitle} onChange={(e) => setForm({ ...form, jobTitle: e.target.value })} className="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" />
          <select value={form.departmentId} onChange={(e) => setForm({ ...form, departmentId: e.target.value })} className="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500">
            <option value="">No department</option>
            {departments?.map((d: any) => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
          <input placeholder="Email" type="email" value={form.workEmail} onChange={(e) => setForm({ ...form, workEmail: e.target.value })} className="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" />
          <button type="submit" disabled={mut.isPending} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">{mut.isPending ? "Saving..." : "Save"}</button>
        </form>
      )}
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Name</th>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Job Title</th>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Department</th>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Email</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {employees?.map((e: any) => {
              const dept = departments?.find((d: any) => d.id === e.department_id);
              return (
                <tr key={e.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 font-medium">{e.name}</td>
                  <td className="px-4 py-3 text-gray-600">{e.job_title ?? "—"}</td>
                  <td className="px-4 py-3">{dept?.name ?? "—"}</td>
                  <td className="px-4 py-3 text-gray-500">{e.work_email ?? "—"}</td>
                </tr>
              );
            })}
            {(!employees || employees.length === 0) && <tr><td colSpan={4} className="px-4 py-8 text-center text-gray-400">No employees</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
